import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';

import Flex from '../../layouts/Flex';

const StyledDrawerHeaderDecoration = styled(Flex)(
  css({
    as: 'span',
    alignSelf: 'flex-end',
    backgroundColor: 'white',
    borderRadius: '50%',
    height: '40px',
    width: '40px',
    paddingTop: '9px',
    marginBottom: '-20px',
    boxShadow: '10',
    'html[dir=ltr] &': {
      paddingLeft: '8px',
    },
    'html[dir=rtl] &': {
      paddingRight: '7px',
    },
  })
);

export const DrawerHeaderDecoration = ({ children }) => {
  return (
    <StyledDrawerHeaderDecoration>{children}</StyledDrawerHeaderDecoration>
  );
};
